import script from "./StepByStepWorkflow.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepByStepWorkflow.vue?vue&type=script&setup=true&lang=ts"

import "./StepByStepWorkflow.vue?vue&type=style&index=0&id=4b67d8bc&lang=scss"

const __exports__ = script;

export default __exports__